import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/jianyan_ic_saoma@2x.png'
import _imports_1 from '@/assets/icon/gon1gdan_ic_saoma@2x.png'
import _imports_2 from '@/assets/icon/gongdan_ic_shoudong@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-09c04256"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lk" }
const _hoisted_2 = { class: "lk_box" }
const _hoisted_3 = { class: "lk_box_title" }
const _hoisted_4 = { class: "lk_box_info" }
const _hoisted_5 = { class: "lk_box_info_item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "所在仓库：", -1))
const _hoisted_7 = { class: "lk_box_info_item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "所在货位：", -1))
const _hoisted_9 = { class: "lk_box_info_item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "质量属性：", -1))
const _hoisted_11 = {
  key: 0,
  class: "green"
}
const _hoisted_12 = {
  key: 1,
  class: "yellow"
}
const _hoisted_13 = {
  key: 2,
  class: "red"
}
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { class: "lk_box_info_item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "产生工序：", -1))
const _hoisted_17 = { class: "lk_box_info_item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "返修工序：", -1))
const _hoisted_19 = { class: "lk_box_info_item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "客返单号：", -1))
const _hoisted_21 = { class: "lk_box_info_item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "客返客户：", -1))
const _hoisted_23 = { class: "lk_scode" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "扫码旧工装", -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "z" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "扫码新工装", -1))
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = { class: "lk_content" }
const _hoisted_32 = { class: "lk_content_jiu" }
const _hoisted_33 = { class: "lk_content_jiu_title" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lk_content_jiu_title_left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "x" }),
  /*#__PURE__*/_createElementVNode("span", null, "旧工装码")
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "新增", -1))
const _hoisted_37 = [
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = { class: "lk_content_jiu_box" }
const _hoisted_39 = { class: "item" }
const _hoisted_40 = { class: "item_wz" }
const _hoisted_41 = {
  key: 0,
  class: "green"
}
const _hoisted_42 = {
  key: 1,
  class: "yellow"
}
const _hoisted_43 = {
  key: 2,
  class: "red"
}
const _hoisted_44 = {
  key: 3,
  class: "green"
}
const _hoisted_45 = { class: "item_num" }
const _hoisted_46 = {
  key: 1,
  class: "items"
}
const _hoisted_47 = { class: "lk_content_jiu" }
const _hoisted_48 = { class: "lk_content_jiu_title" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lk_content_jiu_title_left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "x" }),
  /*#__PURE__*/_createElementVNode("span", null, "新工装码")
], -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "新增", -1))
const _hoisted_52 = [
  _hoisted_50,
  _hoisted_51
]
const _hoisted_53 = { class: "lk_content_jiu_box" }
const _hoisted_54 = { class: "item" }
const _hoisted_55 = { class: "item_wz" }
const _hoisted_56 = {
  key: 0,
  class: "green"
}
const _hoisted_57 = {
  key: 1,
  class: "yellow"
}
const _hoisted_58 = {
  key: 2,
  class: "red"
}
const _hoisted_59 = {
  key: 3,
  class: "green"
}
const _hoisted_60 = { class: "item_num" }
const _hoisted_61 = ["onUpdate:modelValue", "onBlur"]
const _hoisted_62 = {
  key: 1,
  class: "items"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lk_zw" }, null, -1))
const _hoisted_64 = { class: "lk_footer" }
const _hoisted_65 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_66 = [
  _hoisted_65
]

import { ref, reactive, onMounted } from 'vue'
    import { useRoute, useRouter } from "vue-router"
    import { QRCodeType, Attribute } from '@/enum'
    import { Toast } from 'vant'
    import { REGULAR } from '@/utils/utils'
    import { getBarcodeContent, getListByCondition, chageApplicance } from "@/apis/WorkOrderAPI"
    import Tooling from '@/components/common/Tooling.vue'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const route = useRoute()

    const router = useRouter()

    let data = reactive<{ oldList: any, newList: any, type: string | number }>({    // 新旧工装数据
        oldList: [],
        newList: [],
        type: ''
    })

    let gzShow = ref<boolean>(false)
    let info = ref<any>({})    // 详情数据
    let openCode = ref<boolean>(false)
    let type = ref<string>('')

    // 修改新工装数量
    const changeNum = (num: any, i: number, umodelData: number): void => {
        if (umodelData === 0) {
            if (!REGULAR.positiveInteger.test(num)) {
                Toast.fail({ message: '数量只能输入正整数' })
                data.newList.forEach((element: any, index: number) => {
                    if (i === index) {
                        element.num = ''
                    }
                })
            }
        } else if (umodelData === 1) {
            if (!REGULAR.number.test(num)) {
                Toast.fail({ message: '数量只能输入整数或小数(四位)' })
                data.newList.forEach((element: any, index: number) => {
                    if (i === index) {
                        element.num = ''
                    }
                })
            }
            // if (!REGULAR.positiveInteger.test(num) && !REGULAR.decimal.test(num)) {
            //     Toast.fail({ message: '数量只能输入整数或小数' })
            //     data.newList.forEach((element: any, index: number) => {
            //         if (i === index) {
            //             element.num = ''
            //         }
            //     })
            // }
        }
    }

    const openGZ = (Type: number): void => {
        data.type = Type
        gzShow.value = true
    }

    // 删除新旧工装
    const dele = (type: number, i: number): void => {
        if (type === 1) {
            if (data.oldList.length === 1) {
                Toast.fail({ message: '至少保留一项旧工装', duration: 2000 })
                return
            }
            data.oldList.splice(i, 1)
        } else if (type === 2) {
            if (data.newList.length === 1) {
                Toast.fail({ message: '至少保留一项新工装', duration: 2000 })
                return
            }
            data.newList.splice(i, 1)
        }
    }

    // 获取工装数据
    const getValue = (item: any): void => {
        const arr: Array<any> = [...data.oldList, ...data.newList]
        if (data.type == 1) {
            let next: boolean = true
            arr.forEach((element: any) => {
                if (item.id === element.id) {
                    next = false
                    Toast.fail({ message: '不能重复添加相同的工装' })
                    return
                }
            })
            if (next) {
                data.oldList.push(item)
            }
        } else if (data.type == 2) {
            let next: boolean = true
            arr.forEach((element: any) => {
                if (item.id === element.id) {
                    next = false
                    Toast.fail({ message: '不能重复添加相同的工装' })
                    return
                }
            })
            if (next) {
                data.newList.push(item)
            }
        }
        gzShow.value = false
    }

    const close = (): void => {
        gzShow.value = false
    }

    const closePopup = (): void => {
        openCode.value = false
    }

    // 获取扫码回调
    const onDecode = async (datas: string[]): Promise<void> => {
        openCode.value = false
        const arr: Array<any> = [...data.oldList, ...data.newList]
        let res = await getBarcodeContent({    // 扫码请求返回类型和id
            barcode: datas[0]
        })
        if (res.code === 200) {
            if (res.data.barcodeType === QRCodeType.GZ) {
                let infos = await getListByCondition({ id: res.data.id })
                if (infos.code === 200) {

                    if (type.value === 'new') {
                        if (info.value.smodelLabel === infos.data[0].smodelLabel) {
                            // if (infos.data[0].status === 1) {
                                data.newList.push(infos.data[0])
                            // } else {
                            //     Toast.fail({ message: '工装状态必须为空', duration: 2000 })
                            // }
                        } else {
                            Toast.fail({ message: '工装属性不一致', duration: 2000 })
                        }
                        return
                    }

                    let next: boolean = true
                    arr.forEach((element: any) => {
                        if (element.id === infos.data[0].id) {
                            next = false
                            Toast.fail({ message: '不能重复添加相同的工装' })
                        }
                    })
                    if (next) {
                        if (type.value === 'old') {
                            if (info.value.warehouseId === infos.data[0].warehouseId) {
                                if (info.value.locationId === infos.data[0].locationId) {
                                    if (info.value.qualityType === infos.data[0].qualityType) {
                                        if (info.value.procedureId === infos.data[0].procedureId) {
                                            if (info.value.fxpmodelName === infos.data[0].fxpmodelName) {
                                                if (info.value.saleorderId === infos.data[0].saleorderId) {
                                                    if (info.value.cmodelName === infos.data[0].cmodelName) {
                                                        data.oldList.push(infos.data[0])
                                                    } else {
                                                        Toast.fail({ message: '客返客户不一致', duration: 2000 })
                                                    }
                                                } else {
                                                    Toast.fail({ message: '客返单号不一致', duration: 2000 })
                                                }
                                            } else {
                                                Toast.fail({ message: '返修工序不一致', duration: 2000 })
                                            }
                                        } else {
                                            Toast.fail({ message: '产生工序不一致', duration: 2000 })
                                        }
                                    } else {
                                        Toast.fail({ message: '质量属性不一致', duration: 2000 })
                                    }
                                } else {
                                    Toast.fail({ message: '货位不一致', duration: 2000 })
                                }
                            } else {
                                Toast.fail({ message: '仓库不一致', duration: 2000 })
                            }
                        }
                        // else if (type.value === 'new') {
                        //     if (info.value.smodelLabel === infos.data[0].smodelLabel) {
                        //         if (infos.data[0].status === 1) {
                        //             data.newList.push(infos.data[0])
                        //         } else {
                        //             Toast.fail({ message: '工装状态必须为空', duration: 2000 })
                        //         }
                        //     } else {
                        //         Toast.fail({ message: '工装属性不一致', duration: 2000 })
                        //     }
                        // }
                    }
                } else {
                    Toast.fail({ message: '请扫描正确的工装码' })
                }
            }
        }
    }

    // 打开扫一扫
    const openScanCode = (Type: string): void => {
        type.value = Type
        openCode.value = true
    }

    // 获取工装详情
    const getInfo = async () => {
        let res = await getListByCondition({ id: route.query.id })
        if (res.code === 200) {
            info.value = res.data[0]
            data.oldList.push(res.data[0])
        }
    }

    // 提交换篮筐
    const submit = async (): Promise<void> => {
        if (data.oldList.length === 0) {
            Toast.fail({ message: '旧工装不能为空' })
            return
        }
        if (data.newList.length === 0) {
            Toast.fail({ message: '新工装不能为空' })
            return
        }
        let news: number = 0
        let old: number = 0
        data.oldList.forEach((element: any) => {
            old = old + element.num
        })
        data.newList.forEach((element: any) => {
            news = news + element.num
        })
        if (news !== old) {
            Toast.fail({ message: '新旧工装数量必须一致' })
            return
        }
        let res = await chageApplicance({
            oldList: data.oldList,
            newList: data.newList
        })
        if (res.code === 200) {
            Toast.success({ message: '操作成功', forbidClick: true, duration: 3000 })
            setTimeout(() => {
                router.go(-1)
            }, 2000)
        }
    }

    onMounted(() => {
        getInfo()
    })

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell")!
  const _component_v_ScanCode = _resolveComponent("v-ScanCode")!
  const _directive_preventReClick = _resolveDirective("preventReClick")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(info).mmodelName ? _unref(info).mmodelName : '-') + " | " + _toDisplayString(_unref(info).mmodelCode ? _unref(info).mmodelCode : '-') + " | " + _toDisplayString(_unref(info).batch ? _unref(info).batch : '-'), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("span", null, _toDisplayString(_unref(info).whmodelName), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("span", null, _toDisplayString(_unref(info).lmodelUnionName), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          (_unref(info).qualityType === 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, "合格"))
            : (_unref(info).qualityType === 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, "不良"))
              : (_unref(info).qualityType === 2)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, "报废"))
                : (_openBlock(), _createElementBlock("span", _hoisted_14))
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("span", null, _toDisplayString(_unref(info).pmodelName ? _unref(info).pmodelName : '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("span", null, _toDisplayString(_unref(info).fxpmodelName ? _unref(info).fxpmodelName : '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("span", null, _toDisplayString(_unref(info).saleorderId ? _unref(info).saleorderId : '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("span", null, _toDisplayString(_unref(info).cmodelName ? _unref(info).cmodelName : '-'), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", {
        class: "lk_scode_jiu",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (openScanCode('old')))
      }, _hoisted_26),
      _hoisted_27,
      _createElementVNode("div", {
        class: "lk_scode_xin",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (openScanCode('new')))
      }, _hoisted_30)
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("div", {
            class: "lk_content_jiu_title_right",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (openGZ(1)))
          }, _hoisted_37)
        ]),
        _createElementVNode("div", _hoisted_38, [
          (_unref(data).oldList.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(data).oldList, (item, i) => {
                return (_openBlock(), _createBlock(_component_van_swipe_cell, {
                  key: item.code
                }, {
                  right: _withCtx(() => [
                    _createVNode(_component_van_button, {
                      style: {"height":"100%"},
                      square: "",
                      type: "danger",
                      text: "删除",
                      onClick: ($event: any) => (dele(1, i))
                    }, null, 8, ["onClick"])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        (item.smodelLabel === _unref(Attribute).HG)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_41, "[合格]"))
                          : (item.smodelLabel === _unref(Attribute).BL)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_42, "[不良]"))
                            : (item.smodelLabel === _unref(Attribute).BF)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_43, "[报废]"))
                              : (item.smodelLabel === _unref(Attribute).HH)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_44, "[混合]"))
                                : _createCommentVNode("", true),
                        _createElementVNode("span", null, " " + _toDisplayString(item.code), 1)
                      ]),
                      _createElementVNode("div", _hoisted_45, _toDisplayString(item.num) + _toDisplayString(item.umodelName), 1)
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            : (_openBlock(), _createElementBlock("div", _hoisted_46, "暂无数据"))
        ])
      ]),
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, [
          _hoisted_49,
          _createElementVNode("div", {
            class: "lk_content_jiu_title_right",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (openGZ(2)))
          }, _hoisted_52)
        ]),
        _createElementVNode("div", _hoisted_53, [
          (_unref(data).newList.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(data).newList, (item, i) => {
                return (_openBlock(), _createBlock(_component_van_swipe_cell, {
                  key: item.code
                }, {
                  right: _withCtx(() => [
                    _createVNode(_component_van_button, {
                      style: {"height":"100%"},
                      square: "",
                      type: "danger",
                      text: "删除",
                      onClick: ($event: any) => (dele(2, i))
                    }, null, 8, ["onClick"])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, [
                        (item.smodelLabel === _unref(Attribute).HG)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_56, "[合格]"))
                          : (item.smodelLabel === _unref(Attribute).BL)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_57, "[不良]"))
                            : (item.smodelLabel === _unref(Attribute).BF)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_58, "[报废]"))
                              : (item.smodelLabel === _unref(Attribute).HH)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_59, "[混合]"))
                                : _createCommentVNode("", true),
                        _createElementVNode("span", null, " " + _toDisplayString(item.code), 1)
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          "onUpdate:modelValue": ($event: any) => ((item.num) = $event),
                          onBlur: ($event: any) => (changeNum(item.num, i, item.umodelData)),
                          placeholder: "0"
                        }, null, 40, _hoisted_61), [
                          [_vModelText, item.num]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_unref(data).oldList[0].umodelName), 1)
                      ])
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            : (_openBlock(), _createElementBlock("div", _hoisted_62, "暂无数据"))
        ])
      ])
    ]),
    _hoisted_63,
    _createElementVNode("div", _hoisted_64, [
      _withDirectives((_openBlock(), _createElementBlock("button", {
        class: "lk_footer_submit",
        onClick: submit
      }, _hoisted_66)), [
        [_directive_preventReClick]
      ])
    ]),
    _createVNode(_component_v_ScanCode, {
      openCode: _unref(openCode),
      infos: ['请扫描工装码'],
      onClosePopup: closePopup,
      onOnDecode: onDecode
    }, null, 8, ["openCode"]),
    _createVNode(Tooling, {
      show: _unref(gzShow),
      classification: true,
      statusname: '1',
      onClose: close,
      onValue: getValue
    }, null, 8, ["show"])
  ]))
}
}

})